import { shouldIncludePageSize } from './customTileHelpers';
import {
  fetchItems,
  postItemRaw,
  putItemRaw,
  patchItemRaw,
  deleteItem,
} from './queries';
import Cookies from 'js-cookie';
import { getLocalJsonFileByPath } from './localFileRegistry';
import {
  isFileImportQuery,
  resolveFileImportData,
} from './dataImport/fileImportSource';

export async function fetchQueryForPreview(query) {
  if (isFileImportQuery(query)) {
    return await resolveFileImportData(query);
  }
  if (query.dataSource === 'Local File') {
    const file = getLocalJsonFileByPath(query.localFilePath || '');
    if (!file) {
      throw new Error(
        `Local file not found: ${query.localFilePath || '(none selected)'}`
      );
    }
    return file.data;
  }
  const endpoint = query.path?.replace(/^\//, '') || '';
  const params = query.params || {};
  const method = (query.method || 'GET').toUpperCase();
  const token = Cookies.get('sf_token') || null;

  if (['GET'].includes(method)) {
    return await fetchItems(endpoint, params, {
      token,
      includePageSize: shouldIncludePageSize(endpoint),
    });
  } else if (['POST'].includes(method)) {
    let body = query.payload;
    try {
      body = body && typeof body === 'string' ? JSON.parse(body) : body;
    } catch (e) {
      console.error('Error:', e);
    }
    return await postItemRaw(endpoint, body);
  } else if (['PUT'].includes(method)) {
    let body = query.payload;
    try {
      body = body && typeof body === 'string' ? JSON.parse(body) : body;
    } catch (e) {
      console.error('Error:', e);
    }
    return await putItemRaw(endpoint, body);
  } else if (['PATCH'].includes(method)) {
    let body = query.payload;
    try {
      body = body && typeof body === 'string' ? JSON.parse(body) : body;
    } catch (e) {
      console.error('Error:', e);
    }
    return await patchItemRaw(endpoint, body);
  } else if (['DELETE'].includes(method)) {
    return await deleteItem(endpoint, token);
  } else {
    throw new Error(`Unsupported method: ${method}`);
  }
}
